export const isValidPhoneNumber = (phoneNumber: string) =>
  /^(?:\+|00)42[01]\d{9}$/.test(phoneNumber);

export const isNumber = (num: unknown) => !Number.isNaN(Number(num));
